import tictactoess from './tictactoe-ss.jpg'
import kaizenss from './kaizen-ss.jpg'
import cosootss from './cosoot-ss.jpg'
import employeexss from './employeex-ss.jpg'

const projects = [

  {
    'imgurl': cosootss,
    'title': 'Cosoot - Chief Technology Officer',
    'desc': 'Built the analyltics software - Cosoot, using ReactJS, TypeScript, HTML, CSS, MongoDB and TailwindCSS.',
    'link': 'https://cosoot.com/',
    'github': null,
  },
  {
    'imgurl': employeexss,
    'title': 'EmployeeX - Frontend Developer',
    'desc': 'Built a completely responsive and functional website for EmployeeX using ReactJS, HTML, CSS, MongoDB and Bootstrap',
    'link': 'https://www.employeex.co.in/',
    'github': null,
  },
  {
    'imgurl': tictactoess,
    'title': 'Multiplayer online TicTacToe',
    'desc': 'Fun game of online TicTacToe made using Firebase Realtime Database, HTML5, CSS3.',
    'link': 'https://errorassassin.github.io/tic-tac-toe/',
    'github': 'https://github.com/errorassassin/tic-tac-toe/',
  },
  {
    'imgurl': kaizenss,
    'title': 'Kaizen\'24 Website',
    'desc': 'A cool homepage for Kaizen\'24, the NSS fest of IIT Delhi. Check out the hover effects on the website linked below.',
    'link': 'https://kaizeniitd.org/',
    'github': null,
  },

]

export default projects